import { Component, OnInit, AfterViewInit } from '@angular/core';
import { PreloaderService } from '@core';
import { AuthService } from './shared/auth/auth.service';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { SharedService } from '@shared/services/shared.service';
import { MatDialog } from '@angular/material/dialog';
import { MsalBroadcastService } from '@azure/msal-angular';
import { filter } from "rxjs/operators";
import { EventMessage, EventType } from "@azure/msal-browser";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, AfterViewInit {

  defaultRoute: string = 'home';
  loggingIn: boolean = false;
  isIframe:boolean = false;

  constructor(private preloader: PreloaderService,
    private router: Router,
    public sharedService: SharedService,
    public authService: AuthService,
    public dialog: MatDialog,
    private msalBroadcastService: MsalBroadcastService) {}

  redirectFromProfile: string = 'redirectFromProfile';

  userAuthenticated: boolean = false;

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
    //redirect to https for non-development modes
    if (environment.build != "Development" && environment.enableHttpsRedirect) {
      if (location.protocol === 'http:') {
        window.location.href = location.href.replace('http', 'https');
      }
    }
  }

  ngAfterViewInit() {
    this.preloader.hide();
  }

  public authEntireSite() : boolean {
    return environment.authEntireSite;
  }

  public authorized(roles?: string[]): boolean {
    return this.authService.isAuthorized()
  }

  public processing(): boolean {
    return this.authService.isProcessing();
  }

  public homePage(): boolean {
    let page = !this.authService.isProcessing() && 
    ((this.authEntireSite() && this.authorized()) || 
    (!this.authEntireSite()));
    return page;
  }

  public errorPage(): boolean {
    let page = !this.authService.isProcessing() && this.authEntireSite() && !this.authorized();
    return page;
  }

}